import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "item"]

  addItem() {
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  removeItem(event) {
    event.currentTarget.closest("[data-grid-items-target='item']").remove()
  }
}
